import { Card, LegacyStack, Text } from "@shopify/polaris";
import { DromoContainer } from "@vendor-app/app/_sharedComponents/FileImports/components/DromoContainer";
import { BulkUpdateUploadsTable } from "@vendor-app/app/_sharedComponents/FileImports/components/BulkUpdateUploadsTable";

import { dromoBulkUpdateNextOrderDateSchemaId } from "@vendor-app/app/_sharedComponents/FileImports/libs/utils/constants";

export const NextOrderDate = () => {
  return (
    <LegacyStack spacing="loose" vertical>
      <Text variant="bodyMd" as="span" color="subdued">
        Only active subscriptions are eligible for updates. Prepaid or anchor date subscriptions and duplicates
        will be rejected. You&apos;ll be notified if your update succeeds or fails.
      </Text>
      <Card padding="600">
        <LegacyStack spacing="loose" vertical>
          <DromoContainer schemaId={dromoBulkUpdateNextOrderDateSchemaId} uploadType="nextOrderDate" />
        </LegacyStack>
      </Card>
      <BulkUpdateUploadsTable bulkActionType="nextOrderDate" />
    </LegacyStack>
  );
};
